/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketTypeDto } from '../../models/ticket-type-dto';

export interface CenterTicketTypeControllerRemove$Params {
  id: string;
  centerId: string;
}

export function centerTicketTypeControllerRemove(http: HttpClient, rootUrl: string, params: CenterTicketTypeControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketTypeDto>> {
  const rb = new RequestBuilder(rootUrl, centerTicketTypeControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketTypeDto>;
    })
  );
}

centerTicketTypeControllerRemove.PATH = '/api/ticket-type/center/{id}';
